import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AppTabs from '../../components/AppTabs/AppTabs';
import SdoAdminManageRequests from '../../components/SdoAdminManageRequests/SdoAdminManageRequests';
import SdoAdminPilotRequestDetails from '../../components/SdoAdminPilotRequestsDetails/SdoAdminPilotRequestsDetails';
import SdoAdminSetLimits from '../../components/SdoAdminSetLimits/SdoAdminSetLimits';
import './SdoAdminEligibilityCriteria.scss';
import { useHistory } from 'react-router-dom';

export default function SdoAdminEligibilityCriteria() {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(1);
  const { location } = useHistory();
  const [searchState, setSearchState] = useState({
    defaultSearchState: true,
    pilotAutocompleteValue: '',
    pilotAutocompleteId: '',
    sdoDate: 'All',
    sdoPosition: 'All Positions',
    sortModel: [{ field: 'pilot', sort: 'asc' }],
    redirectAutoComplete: false
  });

  const [managedPilotId, setManagedPilotId] = useState('');
  const [goBack, setGoback] = useState(1);
  const [selectedPosition, setSelectedPosition] = useState({
    month: '',
    year: '',
    pos: [{ base: '', equipment: '', rank: '' }]
  });
  const getTabElements = () => {
    const tabElement1 = location.state ? (
      <SdoAdminSetLimits position={location.state.pos} />
    ) : (
      <SdoAdminSetLimits />
    );
    const tabElement2 = (
      <SdoAdminManageRequests
        searchState={searchState}
        setSearchState={setSearchState}
        setManagedPilotId={setManagedPilotId}
        selectedPosition={selectedPosition}
      />
    );
    return [tabElement1, tabElement2];
  };

  const getTabLabels = () => {
    const tabLabels = ['Set Limits', 'Manage Requests'];
    return tabLabels;
  };

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue);
    if (newValue === 1) {
      setSearchState({
        ...searchState,
        defaultSearchState: true
      });
    }
  };

  useEffect(() => {
    if (
      location !== null &&
      location?.state !== null &&
      location?.state !== undefined
    ) {
      let { setLimitTabZero } = location?.state;
      setTabValue(setLimitTabZero);
      //This is for single pilot manage link
      if (location?.state.managedPilotId) {
        setManagedPilotId(location?.state.managedPilotId);
        setGoback(0);
      }
      // Based on Position- ManageAll
      if (
        location?.state.position &&
        location?.state.month &&
        location?.state.year
      ) {
        const formattedPosition: any = location?.state.position.substring(
          0,
          location?.state.position.indexOf('(')
        );
        const allPosArr = formattedPosition
          .split('|')
          .map((item) => item.trim());
        setSelectedPosition({
          month: location?.state.month,
          year: location?.state.year,
          pos: [
            { base: allPosArr[0], equipment: allPosArr[1], rank: allPosArr[2] }
          ]
        });
        setGoback(1);
      }

      if (location.state.isManageAllRedirect) {
        // Update search state if the page is re-direct from Manage All link
        setSearchState({
          ...searchState,
          defaultSearchState: false,
          redirectAutoComplete: true
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="sdo-admin-ec-container">
      <div className="sdo-admin-ec__header">
        <h1>{t('specialDayOff.adminEligibilityCriteria.title')}</h1>
      </div>
      {!managedPilotId ? (
        <AppTabs
          tabLabels={getTabLabels()}
          tabElements={getTabElements()}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
        />
      ) : (
        <SdoAdminPilotRequestDetails
          managedPilotId={managedPilotId}
          setManagedPilotId={setManagedPilotId}
          goBack={goBack}
          selectedPosition={location?.state?.pos}
        />
      )}
    </div>
  );
}
